import { useTranslation } from 'react-i18next';
import { useSurveyResultsFilter } from 'hooks/useSurveyResultsFilter';

export const usePlaceTitle = () => {
	const { t } = useTranslation('results');
	const { surveyFilter } = useSurveyResultsFilter();

	const { region, country, city, office } = surveyFilter;
	const regionTitle = region ? `${region}` : '';
	const cityTitle = city ? `, ${city}` : ' ';
	const officeTitle = office ? `, ${office}` : '';

	if (region && !country) {
		return `( ${region} )`;
	}

	if (country) {
		return `( ${regionTitle}${
			region ? `, ${country}` : country
		}${cityTitle}${officeTitle} )`;
	}

	return `( ${t('titles.global')} )`;
};
